import React from 'react'
import { graphql } from 'relay-runtime'
import styled from '@emotion/styled'
import { useFragment } from 'react-relay'
import CreativeAdvisorInsight from './CreativeAdvisorInsight'
import { theme } from '../../mui'
import { CreativeAdvisorBrand$key } from './__generated__/CreativeAdvisorBrand.graphql'
import { CreativeAdvisorMetaAd$key } from './__generated__/CreativeAdvisorMetaAd.graphql'
import { EmptyState } from '../../components/EmptyState/EmptyState'

interface CreativeAdvisorProps {
  brandFragmentRequest: CreativeAdvisorBrand$key
  metaAdFragmentRequest: CreativeAdvisorMetaAd$key | null
}

export const creativeAdvisorBrandFragment = graphql`
  fragment CreativeAdvisorBrand on Brand {
    name
    insights {
      id
      text
      ...CreativeAdvisorInsight
    }
  }
`

export const creativeAdvisorMetaAdFragment = graphql`
  fragment CreativeAdvisorMetaAd on MetaAd {
    insights {
      id
      text
      ...CreativeAdvisorInsight
    }
  }
`

const S = {
  Wrapper: styled.div`
    max-width: 12rem;
    min-width: 12rem;
  `,
  Header: styled.div`
    color: ${theme.palette.text.disabled};
    font-style: italic;
    margin-bottom: 1rem;
  `,
  Insights: styled.div`
    margin-bottom: 1rem;
  `,
  Divider: styled.div`
    width: 100%;
    border-bottom: 1px solid ${theme.palette.text.disabled};
    margin-bottom: 1rem;
  `,
}

const CreativeAdvisor = ({
  brandFragmentRequest,
  metaAdFragmentRequest,
}: CreativeAdvisorProps) => {
  const brand = useFragment(creativeAdvisorBrandFragment, brandFragmentRequest)
  const metaAd = useFragment(
    creativeAdvisorMetaAdFragment,
    metaAdFragmentRequest
  )

  const emptyState = (
    <EmptyState message="No new recommendations. Purposely will generate more recommendations as we collect more data about the performance of your ads." />
  )

  let content
  let insights
  if (metaAd == null) {
    insights = brand.insights
  } else {
    insights = metaAd.insights
  }
  if (!insights || insights.length === 0) {
    content = emptyState
  } else {
    content = (
      <>
        {insights
          .filter((insight) => insight.text.indexOf('worse than') === -1)
          .map((insight) => (
            <CreativeAdvisorInsight
              key={insight.id}
              fragmentRequest={insight}
            />
          ))}
        <S.Divider />
        {insights
          .filter((insight) => insight.text.indexOf('worse than') > -1)
          .map((insight) => (
            <CreativeAdvisorInsight
              key={insight.id}
              fragmentRequest={insight}
            />
          ))}
      </>
    )
  }
  return (
    <>
      <S.Wrapper>
        <S.Header>For {brand.name}...</S.Header>
        <S.Insights>{content}</S.Insights>
      </S.Wrapper>
    </>
  )
}

export default CreativeAdvisor
